import { Workspace } from "./types";

export default useCalculateUsage;

function getCallTimeAndQuestions(current) {
  return {
    callTime: current.callTime,
    questions: current.questions,
  };
}

function getAggregatedCallTime(current, history) {
  const aggregatedCallTime = history.reduce((acc, { metrics }) => {
    return metrics.callTime + acc;
  }, current.callTime);

  return aggregatedCallTime;
}

function getAggregatedQuestions(current, history) {
  const aggregatedQuestions = history.reduce((acc, { metrics }) => {
    return metrics.questions + acc;
  }, current.questions);

  return aggregatedQuestions;
}

function useCalculateUsage(workspace: Workspace) {
  const { voiceSecLimit, allowedQuestions, company, usage } = workspace;

  const isUsageResetEveryMonth = !(company?.monthlyResetDisabled ?? true);

  const { callTime, questions } = isUsageResetEveryMonth
    ? getCallTimeAndQuestions(usage.current)
    : {
        callTime: getAggregatedCallTime(usage.current, usage.history),
        questions: getAggregatedQuestions(usage.current, usage.history),
      };

  return {
    callTime,
    questions,
    voiceSecLimit,
    allowedQuestions,
  };
}
